module.exports = __webpack_public_path__ + "img/waiting_list.76019e9f.png";